var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndustry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 13.5C2.02632 11.5 2.71053 8.83327 2.71053 4.83321H7.5C7.5 8.83327 8.18421 11.5 9.21053 13.5M7.15789 2.34318C7.95842 1.25183 8.98337 1.25183 9.7839 2.34318C10.2669 3.01252 10.8909 2.98785 11.3856 2.31851C12.1745 1.22716 13.1988 1.22716 14 2.31851",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42368 7.5H10.8554C10.9512 8.73508 10.8458 10.8901 13.1071 13.379M1 13.5H14",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.952d01e90919c8409f74491e3cfe79cb.svg";
export { ForwardRef as ReactComponent };